<template>
    <div :class="$style.sticky_banner">
        <img
            :src="props.game.icon"
            :alt="props.game.title"
            :class="$style.icon"
        />
        <div :class="$style.texts">
            <Typography
                type="label"
                size="m"
                accent
                :class="$style.title"
            >
                {{ props.game.title }}
            </Typography>
            <Typography
                type="label"
                size="xs"
                :class="$style.category"
            >
                {{ props.categories?.categoriesInfo?.[0]?.title || '-' }}
            </Typography>
        </div>
    </div>
</template>

<script setup lang="ts">
import Typography from '@/components/Typography.vue'
import type { APIGameType, GameCategoriesInfoType } from '@/types'

interface GameStickyBannerProps {
    game: APIGameType
    categories?: GameCategoriesInfoType
}

const props = defineProps<GameStickyBannerProps>()
</script>

<style module>
.sticky_banner {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    gap: 8px;
    height: 100%;
    align-items: center;
    padding: 0 12px;
    min-width: 0;
    background-color: var(--black);
    color: var(--white);
}

.icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background-color: #bebebe;
}

.texts {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    min-width: 0;
}

.title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (prefers-color-scheme: light) {
    .sticky_banner {
        background-color: var(--white);
        color: var(--black);
    }
}

.category {
    color: var(--carbon-500);
}

@media (--tablet-plus) {
    .icon {
        width: 48px;
        height: 48px;
    }
}
</style>
